export default __webpack_public_path__ + "static/media/promo_04.edef0798.jpg";